import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import LocaleContext from '../../contexts/LocaleContext';
import { getFooter } from '../../js/api/navigation';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';

export default function FooterNav() {
  const { locale } = useContext(LocaleContext);
  const { t } = useTranslation(['HomePage']);
  const [footerItems, setFooterItems] = useState();
  const { queryParams } = useNavigationWithQuery();

  /**
   * Handle fetching navigation data.
   */
  useEffect(() => {
    getFooter()
      .then((res) => {
        setFooterItems(res.sort((a, b) => a.order - b.order).filter(item => {
          // Filter out donate-now by checking multiple possible fields
          const itemKey = item.uiRouterKey || item.key || '';
          const itemPath = item.path || '';
          const itemTitle = item.title || '';
          return !itemKey.includes('donate') &&
                 !itemPath.includes('donate') &&
                 !itemTitle.toLowerCase().includes('donate') &&
                 !itemTitle.includes('تبرع');
        }));
      })
      .catch((e) => {
        toast.error(t('getFooterLinksError'));
        throw e;
      });
  }, [locale]);

  const footerNavigationLinksJSX = footerItems?.map((item) => (
    <li key={`navigation-list__item-${item.id}`} className="navigation-list__item">
      {item.external ? (
        <a href={`${item.path}${queryParams}`} title={item.title}>
          {item.title}
        </a>
      ) : (
        <Link to={`${locale}${item.path}${queryParams}`} title={item.title}>
          {item.title}
        </Link>
      )}
    </li>
  ));

  return (
    <nav className="navigation container">
      <ul className="navigation-list">{footerNavigationLinksJSX}</ul>
    </nav>
  );
}
